import { GridColDef } from "@mui/x-data-grid";
import { themeStore } from "../themes/BaseTheme";
import { useTheme } from "@mui/material";

export const highlightText = (text, searchText, mode) => {
  if (!searchText) return text;

  const escapedSearchText = searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');

  const parts = String(text).split(new RegExp(`(${escapedSearchText})`, 'gi'));
  return parts.map((part, index) =>
    part.toLowerCase() === searchText.toLowerCase() ? (
      <span key={index} style={{ backgroundColor: mode === "dark" ? '#FF5E0E' : '#FFC82A' }}>
        {part}
      </span>
    ) : (
      part
    )
  );
};

// Add renderCell for columns to include highlighting
export const highlightedGridColumns = (
  columns: GridColDef<any, any, any>[],
  searchText: string,
  apiRef: any
) => {
  const mode = themeStore.getState().theme.palette.mode;

  return columns.map((column) => ({
    ...column,
    renderCell: (params) => {
      let value =
        column.valueGetter
          ? column.valueGetter(undefined as never, params.row, column, apiRef)
          : params.value;

      // Handle boolean display
      if (typeof value === 'boolean') {
        value = value ? 'Ja' : 'Nei';
      }

      return <div>{highlightText(value, searchText, mode)}</div>;
    },
  }));
};